import { ActionButtonType } from "@enums/actionButtonType";
import { ProjectFeatureType } from "@enums/projectFeatureType";
import banProject from "@services/Project/banProject";
import featureProject from "@services/Project/featureProject";
import { useEffect, useState } from "react";
import TObjectFilledWithStrings from "types/Shared/objectFilledWithStrings";

interface IUseListProjectProps {
  isBanModalOpen: boolean;
  isFeatureModalOpen: boolean;
  handleBan: () => void;
  handleIsBanModalOpen: () => void;
  handleIsFeatureModalOpen: () => void;
  handleFeature: (
    unlist: boolean,
    type: ProjectFeatureType,
    order: number
  ) => void;
}

const useListProject = (
  basicData: TObjectFilledWithStrings | undefined,
  getItems: () => void
): IUseListProjectProps => {
  const [isBanModalOpen, setIsBanModalOpen] = useState(false);
  const [isFeatureModalOpen, setIsFeatureModalOpen] = useState(false);

  const handleBan = async () => {
    if (basicData?.uuid) {
      banProject(basicData.uuid)
        .then(() => {
          getItems();
        })
        .finally(() => handleIsBanModalOpen());
    }
  };

  const handleFeature = async (
    unlist: boolean,
    type: ProjectFeatureType,
    order: number
  ) => {
    if (basicData?.uuid) {
      featureProject(basicData?.uuid, unlist, type, order)
        .then(() => getItems())
        .finally(() => handleIsFeatureModalOpen());
    }
  };

  const handleIsBanModalOpen = () => {
    setIsBanModalOpen(!isBanModalOpen);
  };

  const handleIsFeatureModalOpen = () => {
    setIsFeatureModalOpen(!isFeatureModalOpen);
  };

  useEffect(() => {
    if (basicData?.uuid) {
      if (basicData?.actionButtonType === ActionButtonType.Ban) {
        handleIsBanModalOpen();
      } else {
        handleIsFeatureModalOpen();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basicData]);

  return {
    isBanModalOpen,
    isFeatureModalOpen,
    handleBan,
    handleIsBanModalOpen,
    handleIsFeatureModalOpen,
    handleFeature,
  };
};

export default useListProject;
